import ProgressBar from './progress-bar/progress-bar.vue'
import InputFile from './input-file/input-file.vue'

export default {
    ProgressBar,
    InputFile
};